/**
 * v0.9.1643: make window.prompt work inside the Windows desktop shell.
 *
 * Electron does not implement window.prompt. It returns null with no dialog,
 * so a caller written as `const v = window.prompt(...)` silently takes the
 * "cancelled" branch and the button looks broken. Twelve places do exactly
 * that - House Accounts payments, Menu item copy, Clock In, Website SEO, Dev
 * Panel, Admin, ServerPanel - and several are money paths.
 *
 * The shell (v1.2.1) exposes `window.nexttabShell.prompt`, which opens a real
 * modal and blocks until it is answered, the same contract the DOM API has.
 * Swapping it in here fixes every caller at once, with no change to any of
 * them - and it lives in the frontend, which ships on a refresh, rather than
 * in the shell, which ships as an installer.
 *
 * Everywhere else (iPad, Android, a browser) this does nothing: the platform
 * prompt already works.
 */

type ShellApi = { prompt?: (message: string, defaultValue?: string) => string | null };

export function installShellPrompt(): void {
  if (typeof window === 'undefined') return;
  const shell = (window as unknown as { nexttabShell?: ShellApi }).nexttabShell;
  if (!shell || typeof shell.prompt !== 'function') return;
  window.prompt = (message?: string, defaultValue?: string): string | null =>
    shell.prompt!(String(message ?? ''), defaultValue == null ? '' : String(defaultValue));
}
